<template>
  <AttrGroup title="排版">
    <!-- <AttrTypography
      :value="
        !!shape.attrs.source || !!attrDisabled
          ? runtimeValue
          : shape.attrs.text ?? ''
      "
      :readonly="!!shape.attrs.source || !!attrDisabled"
      :readonly-tooltip="shape.attrs.source ?? ''"
      @change="(e: any) => shape.setAttrs({text:e.target?.value??'' })"
    /> -->
    <AttrRichText
      :value="shape.attrs.strings"
      :shape="shape"
      @change="(v: TextString[]) => shape.setAttrs({ strings: v })"
    />
    <!-- <div style="white-space: pre-wrap">
      {{ JSON.stringify(shape.attrs.strings, null, 2) }}
    </div> -->

    <!-- 字体 字重  -->
    <div class="mt-2.5">
      <FontFamily :shape="shape" />
    </div>
    <!-- 字号 -->
    <div class="mt-2.5">
      <FontSizeGap :shape="shape" />
    </div>

    <!-- longMode模式 -->
    <!-- <div class="mt-2.5">
      <TextLongMode :shape="shape" />
    </div> -->

    <!-- 对齐方式和宽高 -->
    <div class="mt-2.5 grid grid-cols-2 gap-2.5">
      <AttrAlign
        :value="shape?.attrs?.align"
        :disabled="
          (!!shape.attrs.sizeContent && shape.attrs.style == 'normal') ||
          !!attrDisabled
        "
        @change="(v: any) => shape.setAttrs({ align: v })"
      />
      <AttrTextWidth
        :value="shape?.attrs?.sizeContent ?? false"
        :disabled="
          (shape.attrs as TextAttribute).style == 'arc' || !!attrDisabled
        "
        @change="onChangeSizeContent"
      />
    </div>

    <!-- 颜色 -->
    <!-- <AttrColor
      :value="shape.attrs.color"
      class="mt-2.5"
      :disabled="!!attrDisabled"
      @change="(v:string) => shape.setAttrs({ color:v})"
    /> -->

    <!-- 文字排布 -->
    <AttrSelect
      class="mt-2.5"
      label="文字排布"
      :value="shape.attrs.style"
      :options="[
        { label: '横排', value: 'normal' },
        { label: '弧形文本', value: 'arc' }
      ]"
      :disabled="!!attrDisabled"
      @change="(val: any) => shape.setAttrs({ style: val })"
    />
    <!-- 弧形文本属性 -->
    <template v-if="(shape.attrs as TextAttribute).style == 'arc'">
      <!-- 显示辅助圆 -->
      <AttrSwitch
        class="mt-2.5"
        label="辅助圆及辅助线"
        :value="editorStore.arcAuxiliary?.type != 'none'"
        @change="
          (v: boolean) => updateAuxiliaryType(v ? 'circle' : 'none', true)
        "
      />
      <AttrInputNumber
        class="mt-2.5"
        :value="shape.attrs['radius']"
        label="圆弧半径"
        :min="1"
        addon-after="px"
        :width="58"
        :disabled="!!attrDisabled"
        @change="(val: any) => shape.setAttrs({ radius: val })"
        @mouseenter="() => updateAuxiliaryType('radius')"
        @mouseleave="() => updateAuxiliaryType('circle')"
      />
      <div class="mt-2.5 grid grid-cols-2 gap-2.5">
        <AttrInputNumber
          class=""
          :value="shape.attrs['arcSpan'] ?? 45"
          label="弧度"
          :min="1"
          :max="360"
          addon-after="°"
          :width="58"
          :disabled="!!attrDisabled"
          @change="(val: any) => shape.setAttrs({ arcSpan: val })"
          @mouseenter="() => updateAuxiliaryType('span')"
          @mouseleave="() => updateAuxiliaryType('circle')"
        />
        <AttrInputNumber
          class=""
          :value="shape.attrs['startAngle'] ?? 0"
          label="起始角度"
          :width="52"
          addon-after="°"
          :disabled="!!attrDisabled"
          @change="(val: any) => shape.setAttrs({ startAngle: val })"
          @mouseenter="() => updateAuxiliaryType('angleStart')"
          @mouseleave="() => updateAuxiliaryType('circle')"
        />
      </div>

      <!-- 竖向对齐方式 -->
      <AttrSelect
        v-if="canUse('verticalAlign').valid"
        class="mt-2.5"
        label="文字垂直位置"
        :value="shape.attrs.verticalAlign ?? 'top'"
        :options="[
          // 这里label的是文本和圆弧的相对位置，value是协议中定义的
          { label: '底部对齐', value: 'top' },
          { label: '居中', value: 'center' },
          { label: '顶部对齐', value: 'under' }
        ]"
        :disabled="!!attrDisabled"
        @change="(val: any) => shape.setAttrs({ verticalAlign: val })"
      />

      <!-- 文字排布方向 -->
      <AttrSwitch
        class="mt-2.5"
        label="翻转文字方向"
        :value="shape.attrs['reverseText']"
        :disabled="!!attrDisabled"
        @change="
          (v: boolean) => {
            shape.setAttrs({ reverseText: v });
          }
        "
      />
    </template>
  </AttrGroup>

  <!-- 绑定数据 -->
  <div class="mt-2.5">
    <attr-data-source-text :shape="shape" />
  </div>
</template>

<script lang="ts" setup>
import { Shape } from '@/services/shape';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { TextAttribute, TextString } from '@/services/shape/attributes/text';
import { useEditorStore } from '@/store/use-editor-store';
import { useRuntimeStore } from '@/store/use-runtime-store';
import { canUse } from '@/utils/can-use.utils';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const editorStore = useEditorStore();
const runtimeStore = useRuntimeStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const onChangeSizeContent = (v: boolean) => {
  const shape = props.shape;
  const data: Parameters<typeof shape.setAttrs>[0] = {
    sizeContent: v
  };
  // 切到固定尺寸时，用当前渲染的宽高同步到 attrs，避免 h 沿用旧值导致与自适应时不一致（如 h 从 27 变成 21）
  if (shape.attrs.style == 'normal' && v == false) {
    const state = runtimeStore.shapeState(shape.id);
    data.w = state?.textWholeWidth ?? shape.attrs.w;
    data.h = state?.height ?? shape.attrs.h;
  }
  shape.setAttrs(data);
};

const updateAuxiliaryType = (type: string, force?: boolean) => {
  if (editorStore.arcAuxiliary.type == 'none' && !force) return;
  editorStore.arcAuxiliary.type = type;
  editorStore.arcAuxiliary.shapeId = props.shape.id;
};
</script>
